export enum DocumentTypes {
  CC = 'CC',
  CE = 'CE',
}

export const documentTitles: Record<DocumentTypes, string> = {
  [DocumentTypes.CC]: 'Cédula de ciudadanía',
  [DocumentTypes.CE]: 'Cédula de extranjería',
};

export const documentTypeList = [DocumentTypes.CC, DocumentTypes.CE];
